module.exports = __webpack_public_path__ + "static/media/cat.b440489e.gif";